// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- PARENT CONTAINER --- */
.central-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  
  /* FORCE VARIABLES ON ALL CHILDREN */
  --local-bg: #121212;
  --local-strip: #1a1a1a;
  --local-border: #2b2b2b;
  --local-text: #e1e1e1;
  
  background-color: var(--local-bg);
  color: var(--local-text);
}

/* --- THE STRIP (FORCED) --- */
.central-controls-strip {
  /* NO HARDCODED #f8f8f8 ANYMORE */
  background: var(--local-strip);
  border-bottom: 1px solid var(--local-border);
  z-index: 10;
  height: var(--topPanelHeight, 200px); /* Dynamically set from React */
}

/* --- THE VIEWPORT (FORCED) --- */
.central-unit-viewport {
  background-color: var(--local-bg);  
  flex-grow: 1; /* Take up remaining space */
  overflow-y: auto; /* Enable vertical scroll */
  position: relative;
}
/* --- THE NOTIFICATION (STAY BRIGHT) --- */
.central-notification {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #2e7d32; /* Slightly darker green for dark mode */
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.5);
  z-index: 1000;
}








`, "",{"version":3,"sources":["webpack://./src/TractumUI/components/Central/Central1.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;;EAEhB,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;;EAErB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4CAA4C;EAC5C,WAAW;EACX,oCAAoC,EAAE,+BAA+B;AACvE;;AAEA,kCAAkC;AAClC;EACE,iCAAiC;EACjC,YAAY,EAAE,4BAA4B;EAC1C,gBAAgB,EAAE,2BAA2B;EAC7C,kBAAkB;AACpB;AACA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB,EAAE,wCAAwC;EACnE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;AACf","sourcesContent":["/* --- PARENT CONTAINER --- */\n.central-root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  \n  /* FORCE VARIABLES ON ALL CHILDREN */\n  --local-bg: #121212;\n  --local-strip: #1a1a1a;\n  --local-border: #2b2b2b;\n  --local-text: #e1e1e1;\n  \n  background-color: var(--local-bg);\n  color: var(--local-text);\n}\n\n/* --- THE STRIP (FORCED) --- */\n.central-controls-strip {\n  /* NO HARDCODED #f8f8f8 ANYMORE */\n  background: var(--local-strip);\n  border-bottom: 1px solid var(--local-border);\n  z-index: 10;\n  height: var(--topPanelHeight, 200px); /* Dynamically set from React */\n}\n\n/* --- THE VIEWPORT (FORCED) --- */\n.central-unit-viewport {\n  background-color: var(--local-bg);  \n  flex-grow: 1; /* Take up remaining space */\n  overflow-y: auto; /* Enable vertical scroll */\n  position: relative;\n}\n/* --- THE NOTIFICATION (STAY BRIGHT) --- */\n.central-notification {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: #2e7d32; /* Slightly darker green for dark mode */\n  color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.5);\n  z-index: 1000;\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
